
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import * as R from "ramda";
import $ from 'jquery';
import { useHistory } from 'react-router';
import { UpdateUserCreation } from '../../actions/funecap/dossiers';
import * as Loadings from '../../constants/loadings/funecap/dossiers';

export const ChangeCharge = ({ selectedUser, users, isLoading }) => {
	const dispatch = useDispatch();
	const history = useHistory();
	const [selectedCharge, setSelectedCharge] = useState(R.isNil(selectedUser) ? undefined : selectedUser.creationUserId);

	useEffect(() => {
		if(!R.isNil(selectedUser)){
			setSelectedCharge(selectedUser.creationUserId);
		}
	}, [selectedUser])

	if(R.isNil(selectedUser)){
		return "";
	}

	return (
		<div className="modal fade px-0" id="changeCharge" aria-labelledby="changeChargeLabel" aria-hidden="true" >
			<div className="modal-dialog px-2">
				<div className="modal-content">
					<header className="modal-header">
						<div className="alert bg-common rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
							<h1 className="sr-only visually-hidden">Change Charge</h1>
							<div className="flex-row align-items-center justify-content-between">
								<div className="h4 text-primary text-uppercase mb-0 font-weight-bolder ls-n1 lh-1 mx-auto" id="changeChargeLabel">Changer de chargé du dossier {selectedUser.firstName} {selectedUser.lastName}</div>
								<button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
									<i className="eva eva-close fs-4"></i>
								</button>
							</div>
						</div>
					</header>
					<div className="modal-body scroll-default py-0">
						<section className="card card-body bg-light rounded">
							<form className="form" noValidate id="useraccountForm">
								<div className="form-group">
									<label className="h6 font-weight-bolder" htmlFor="statut">Chargé</label>
									<select className="custom-select" id="statut" tabIndex={-98} value={selectedCharge} onChange={(e) => { setSelectedCharge(e.target.value) }}>
										{users.map(user => {
											return (
												<option key={user.id} value={user.id}>
													{user.firstName} {user.lastName}
												</option>
											);
										})}
									</select>
								</div>
							</form>
						</section>
					</div>
					<div className="modal-footer">
						<button type="button" className="btn btn-light" data-dismiss="modal">Fermer</button>
						{
							isLoading.includes(Loadings.UPDATING_USERCREATION) ? 
								<button type="button" className="btn btn-info loading-btn show">Enregistrer<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div></button>
							:
								<button type="button" className="btn btn-info" onClick={
									(e) => {
										e.preventDefault();
										dispatch(UpdateUserCreation(selectedUser.id, selectedCharge))
										.then(() => {
											$('.modal').modal("hide");
										})
									}
								}>Enregistrer</button>
						}
						
					</div>
				</div>
			</div>
		</div>
	)
}